import React, { useState } from 'react';
import { Trans } from '@lingui/macro';

function Terms() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  return (
    <section className="section bg-light py-0" id="terms">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-12 mb-4 pb-2">
            <div className="section-title text-center">
              <p className="para-desc mx-auto">
                <a 
                  href="#!" 
                  className="text-primary" 
                  onClick={(e) => {
                    e.preventDefault();
                    toggleModal();
                  }}
                >
                  <Trans>General Terms & Conditions</Trans>
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Modal/Popup */}
      {isModalOpen && (
        <div className="modal" style={{
          position: 'fixed',
          top: '0',
          left: '0',
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(0,0,0,0.5)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: '1000'
        }}>
          <div className="modal-content" style={{
            backgroundColor: 'white',
            padding: '2rem',
            borderRadius: '8px',
            maxWidth: '800px',
            maxHeight: '80vh',
            overflowY: 'auto',
            position: 'relative'
          }}>
            <button 
              onClick={toggleModal}
              style={{
                position: 'absolute',
                top: '1rem',
                right: '1rem',
                background: 'none',
                border: 'none',
                fontSize: '1.5rem',
                cursor: 'pointer'
              }}
            >
              &times;
            </button>


            <h3><Trans>GENERAL TERMS & CONDITIONS</Trans></h3>
            <p><strong><Trans>Last Updated:</Trans></strong> 09-05-2025</p>

            <h4>1. <Trans>Scope & Applicability</Trans></h4>
            <p><Trans>These General Terms and Conditions (the "Terms") apply to all ticket purchases, entries, and services related to Amare Music Festival (the "Festival"). By purchasing a ticket or attending the Festival, you agree to these Terms.</Trans></p>

            <h4>2. <Trans>Ticket Purchase & Delivery</Trans></h4>
            <ul>
            <li><Trans>All sales are final—no refunds, exchanges, or cancellations except as required by law.</Trans></li>
            <li><Trans>Lost, stolen, or damaged tickets will not be replaced.</Trans></li>
            <li>
                <Trans>The Festival reserves the right to cancel, postpone, or modify the event due to force majeure including:</Trans>
                <ul>
                <li><Trans>Natural disasters</Trans></li>
                <li><Trans>Government orders</Trans></li>
                <li><Trans>Labor disputes</Trans></li>
                <li><Trans>Utility failures</Trans></li>
                </ul>
            </li>
            </ul>

            <h4>3. <Trans>Entry & Security</Trans></h4>
            <ul>
            <li><Trans>A valid ticket and government-issued ID are required for entry.</Trans></li>
            <li>
                <Trans>The Festival reserves the right to deny entry or remove attendees for:</Trans>
                <ul>
                <li><Trans>Violating these Terms</Trans></li>
                <li><Trans>Dangerous, disruptive, or illegal behavior</Trans></li>
                <li><Trans>Possession of prohibited items (weapons, drugs, etc.)</Trans></li>
                <li><Trans>Intoxication or impairment</Trans></li>
                </ul>
            </li>
            <li><Trans>Security checks (bag searches, pat-downs, metal detectors) are mandatory.</Trans></li>
            </ul>

            <h4>4. <Trans>Prohibited Items & Conduct</Trans></h4>
            <p><Trans>Attendees must not bring:</Trans></p>
            <ul>
            <li><Trans>Illegal substances or drug paraphernalia</Trans></li>
            <li><Trans>Weapons of any kind (including sharp objects)</Trans></li>
            <li><Trans>Professional recording equipment (detachable lenses)</Trans></li>
            <li><Trans>Outside food/drinks</Trans></li>
            <li><Trans>Glass containers, aerosols, or flammable materials</Trans></li>
            </ul>
            <p><em><Trans>This list is not exhaustive. Security reserves full discretion to refuse any item. All persons and belongings are subject to search. See FAQ for a more complete list.</Trans></em></p>

            <h4>5. <Trans>Liability & Risk</Trans></h4>
            <ul>
            <li>
                <Trans>Attendees participate at their own risk. To the maximum extent permitted by Quebec law:</Trans>
                <ul>
                <li><Trans>The Festival's liability shall not exceed the ticket price paid</Trans></li>
                <li><Trans>We are not liable for personal injury, theft, or property damage</Trans></li>
                <li><Trans>You waive claims for consequential/incidental damages</Trans></li>
                </ul>
            </li>
            <li><Trans>You are responsible for your own safety and belongings</Trans></li>
            </ul>

            <h4>6. <Trans>Filming & Photography</Trans></h4>
            <ul>
            <li><Trans>The Festival may capture photos/videos for promotional use. By attending, you grant perpetual rights for commercial use.</Trans></li>
            <li><Trans>Unauthorized professional recording or commercial use of footage is prohibited.</Trans></li>
            </ul>

            <h4>7. <Trans>Event Changes</Trans></h4>
            <ul>
            <li><Trans>Lineup, schedules, and venues are subject to change without notice.</Trans></li>
            <li><Trans>No refunds for artist cancellations, stage changes, or weather impacts.</Trans></li>
            </ul>

            <h4>8. <Trans>Age & ID Requirements</Trans></h4>
            <ul>
            <li><Trans>The Festival is strictly 18+. No exceptions.</Trans></li>
            <li>
                <Trans>Valid government-issued photo ID required for:</Trans>
                <ul>
                <li><Trans>Entry</Trans></li>
                <li><Trans>Alcohol purchases</Trans></li>
                <li><Trans>Will-call ticket pickup</Trans></li>
                </ul>
            </li>
            </ul>

            <h4>9. <Trans>Payments & Currency</Trans></h4>
            <ul>
            <li><Trans>All transactions are processed in </Trans><strong><Trans>Canadian Dollars (CAD)</Trans></strong></li>
            <li><Trans>International cards are subject to exchange rates and bank fees determined by your financial institution</Trans></li>
            <li>
                <Trans>Accepted payment methods:</Trans>
                <ul>
                <li><Trans>Credit/Debit (Visa, Mastercard)</Trans></li>
                </ul>
            </li>
            <p><Trans>All advertised ticket prices include a non-refundable 3% processing fee. Quebec sales tax (QST/GST) applies to the total amount.</Trans></p>
            <p>
                <Trans>All advertised ticket prices include applicable taxes:</Trans>
                <ul>
                <li><Trans>Quebec Sales Tax (QST): 9.975%</Trans></li>
                <li><Trans>Goods and Services Tax (GST): 5.000%</Trans></li>
                </ul>
            </p>
            </ul>

            <h4>10. <Trans>Privacy Policy</Trans></h4>
            <ul>
            <li>
                <strong><Trans>Data Collected:</Trans></strong>
                <ul>
                <li><Trans>Purchase information (name, email, address, type of credit card used)</Trans></li>
                <li><Trans>Device data (IP address, browser type)</Trans></li>
                </ul>
            </li>
            <li>
                <strong><Trans>Usage:</Trans></strong>
                <ul>
                <li><Trans>Order processing and fraud prevention</Trans></li>
                <li><Trans>Personalized marketing</Trans></li>
                <li><Trans>Security and crowd analytics</Trans></li>
                </ul>
            </li>
            <li>
                <strong><Trans>Third Parties:</Trans></strong>
                <ul>
                <li><Trans>Payment processors (Stripe)</Trans></li>
                <li><Trans>Ticketing platform (LYDIA Technology Services)</Trans></li>
                </ul>
            </li>
            <li>
                <strong><Trans>Your Rights:</Trans></strong>
                <ul>
                <li><Trans>Access/delete your data by emailing privacy@amarefestival.com</Trans></li>
                <li><Trans>Subject to Quebec's </Trans><em><Trans>Act Respecting the Protection of Personal Information</Trans></em></li>
                </ul>
            </li>
            </ul>

            <h4>11. <Trans>Cancellation & Refunds</Trans></h4>
            <ul>
            <li><Trans>Refunds processed in CAD to original payment method</Trans></li>
            <li><Trans>International refunds may incur currency conversion losses</Trans></li>
            <li><Trans>If the Festival is canceled entirely, refunds will be issued by Groupe AMARE within 30 days to original payment method, minus processing fees (3%).</Trans></li>
            <li>
                <Trans>No refunds for:</Trans>
                <ul>
                <li><Trans>Partial cancellations (artist no-shows, stage closures)</Trans></li>
                <li><Trans>Weather disruptions</Trans></li>
                <li><Trans>Personal no-shows</Trans></li>
                <li><Trans>Denied entry due to policy violations</Trans></li>
                </ul>
            </li>
            <li>
                <Trans>For rescheduled events:</Trans>
                <ul>
                <li><Trans>Tickets automatically transfer to new date</Trans></li>
                <li><Trans>Refund requests must be made within 7 days of reschedule announcement</Trans></li>
                </ul>
            </li>
            <li><em><Trans>Quebec residents: Your rights under the Consumer Protection Act remain unaffected where applicable.</Trans></em></li>
            </ul>

            <h4>12. <Trans>Governing Law</Trans></h4>
            <ul>
            <li><Trans>These Terms are governed by the laws of Quebec and applicable Canadian federal laws.</Trans></li>
            <li><Trans>Any disputes shall be subject to the exclusive jurisdiction of Quebec courts.</Trans></li>
            <li><em><Trans>Les présentes conditions sont rédigées en anglais. En cas de divergence, la version anglaise prévaudra.</Trans></em></li>
            </ul>

            <h4>13. <Trans>Accessibility</Trans></h4>
            <ul>
            <li><Trans>Service animals permitted with 72-hour advance notice to info@amarefestival.com</Trans></li>
            </ul>

            <p>
            <strong><Trans>Contact:</Trans></strong><br />
            <Trans>For questions, contact <a href="mailto:info@amarefestival.com">info@amarefestival.com</a> (response within 5 business days).</Trans><br />
            <em><Trans>These Terms supersede all prior versions.</Trans></em>
            </p>


          </div>
        </div>
      )}
    </section>
  );
}

export default Terms;
